import React, { useEffect, useState } from 'react';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { clinic, navLinks } from '../data/navigation';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-white/90 backdrop-blur-md transition-[border-color,box-shadow] duration-200 ease-soft ${scrolled ? 'border-b border-line shadow-[0_1px_24px_rgba(17,17,17,0.04)]' : 'border-b border-transparent'}`} data-id="element-51" data-mp="2wk714e47ezpy">
      <div className="mx-auto flex h-20 max-w-shell items-center justify-between gap-6 px-6 lg:px-10" data-id="element-52" data-mp="3baocoqajz60k">
        <a href="#top" className="group flex flex-col leading-none" data-id="element-53" data-mp="3fb8a7uz1gbn8">
          <span className="text-[1.35rem] font-medium tracking-tight text-ink" data-id="element-54" data-mp="3f9dqgjzi6pkq">
            Sara<span className="text-champagne" data-id="element-55" data-mp="2wirprr39wrsl">&rsquo;</span>s
          </span>
          <span className="mt-1 text-[0.6rem] uppercase tracking-overline text-ink-muted" data-id="element-56" data-mp="2rk6n7l0jtw0z">
            Plastic Surgery &amp; Med Spa
          </span>
        </a>

        <nav aria-label="Primary" className="hidden lg:block" data-id="element-57" data-mp="2ho3koe1sbvdi">
          <ul className="flex items-center gap-9" data-id="element-58" data-mp="2hpoeg1g9zaab">
            {navLinks.map(link => <li key={link.label} data-id="element-59" data-mp="3fdf197hspnr3">
                <a href={link.href} className="text-sm text-ink-soft transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-60" data-mp="3abponnexd20w">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="hidden items-center gap-6 lg:flex" data-id="element-61" data-mp="1wzaccnd9ff2">
          <a href={clinic.phoneHref} className="flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-soft hover:text-champagne-dark" data-id="element-62" data-mp="1yis67oo7yiy">
            <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-63" data-mp="1rfo2bpiaejfu" />
            {clinic.phoneDisplay}
          </a>
          <a href="#consultation" className="bg-ink px-6 py-3 text-xs uppercase tracking-overline text-white transition-colors duration-150 ease-soft hover:bg-champagne-dark" data-id="element-64" data-mp="1weh44ko7om06">
            Book A Consultation
          </a>
        </div>

        <button type="button" onClick={() => setMenuOpen(open => !open)} className="-mr-2 p-2 text-ink lg:hidden" aria-expanded={menuOpen} aria-controls="mobile-nav" aria-label={menuOpen ? 'Close menu' : 'Open menu'} data-id="element-65" data-mp="18likcxz1lnlk">
          {menuOpen ? <XIcon className="h-5 w-5" data-id="element-66" data-mp="13o8w3lne3hzb" /> : <MenuIcon className="h-5 w-5" data-id="element-67" data-mp="2t2x7bjk8utvr" />}
        </button>
      </div>

      {menuOpen && <div id="mobile-nav" className="border-t border-line bg-white lg:hidden" data-id="element-68" data-mp="2t13vzqyorlhf">
          <nav aria-label="Mobile" className="mx-auto max-w-shell px-6 py-4" data-id="element-69" data-mp="2xzxdduh3fwmv">
            <ul className="divide-y divide-line" data-id="element-70" data-mp="mf69yo308y4f">
              {navLinks.map(link => <li key={link.label} data-id="element-71" data-mp="hgwcg6tt5lfn">
                  <a href={link.href} onClick={() => setMenuOpen(false)} className="block py-3.5 text-sm text-ink-soft" data-id="element-72" data-mp="hdqpoy8nivn3">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <div className="mt-5 flex flex-col gap-3 pb-2" data-id="element-73" data-mp="1062zu75jr17s">
              <a href="#consultation" onClick={() => setMenuOpen(false)} className="bg-ink px-6 py-3.5 text-center text-xs uppercase tracking-overline text-white" data-id="element-74" data-mp="105jfykwc62r4">
                Book A Consultation
              </a>
              <a href={clinic.phoneHref} className="py-1 text-center text-sm text-ink" data-id="element-75" data-mp="3gvqekfg5y1nb">
                {clinic.phoneDisplay}
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}